import { render } from "./CoefficientPopup.vue?vue&type=template&id=040532a8&scoped=true"
import script from "./CoefficientPopup.vue?vue&type=script&lang=js"
export * from "./CoefficientPopup.vue?vue&type=script&lang=js"

import "./CoefficientPopup.vue?vue&type=style&index=0&id=040532a8&scoped=true&lang=scss"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040532a8"]])

export default __exports__